import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	userReportBreadcrumb: {
		id: 'spa-apps-software-breadcrumbs.user.user-report-breadcrumb',
		defaultMessage: 'Reports',
		description: 'Breadcrumb to reports in a user classic software project.',
	},
});
